<template>
  <v-navigation-drawer
    :value="value"
    width="400"
    right
    fixed
    temporary
    @input="$emit('input', $event)"
  >
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex">
          <h2>{{ $t("title.filters") }}</h2>

          <v-spacer />

          <v-btn
            icon
            class="mr-2"
            :aria-label="$t('label.button.clearFilters')"
            :title="$t('label.button.clearFilters')"
            @click="$emit('reset')"
          >
            <v-icon>mdi-filter-off</v-icon>
          </v-btn>

          <v-btn
            icon
            :aria-label="$t('label.button.closeFilters')"
            :title="$t('label.button.closeFilters')"
            @click="$emit('input', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <slot />
    </v-container>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "FilterDrawer",

  props: {
    value: { type: Boolean, default: false },
  },
};
</script>
